import {useCallback, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {UPDATE_MULTIPLE_DATES_MODAL} from '~/SignUpSheets/reducers/sheet/constants';
import {useOutsideAlerter} from '~/SignUpSheets/hooks/useOutsideAlerter';
import './MultipleDatesDropdownMenu.sass';

export const MultipleDatesDropdownMenu = ({open, onClose, onClickAddAnother}) => {
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);

  useOutsideAlerter(dropdownRef, onClose);

  const openMultipleDatesModal = useCallback(
    () =>
      dispatch({
        type: UPDATE_MULTIPLE_DATES_MODAL,
        payload: {open: true},
      }),
    []
  );

  const onButtonClickHandler = useCallback(
    (fn) => () => {
      onClose();
      fn();
    },
    [onClose]
  );

  if (!open) {
    return null;
  }

  return (
    <div className="multiple-dates-dropdown-menu" ref={dropdownRef}>
      <Button
        data-qa-id="add-single-date"
        onClick={onButtonClickHandler(onClickAddAnother)}
        variant="unstyled-button"
        className="multiple-dates-dropdown-menu__item"
      >
        <Typography variant="paragraph2">Add single date</Typography>
      </Button>
      <Button
        data-qa-id="add-multiple-dates"
        onClick={onButtonClickHandler(openMultipleDatesModal)}
        variant="unstyled-button"
        className="multiple-dates-dropdown-menu__item"
      >
        <Typography variant="paragraph2">Add multiple dates</Typography>
      </Button>
    </div>
  );
};
